import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sm:flex-1 sm:flex sm:items-center" }

import { computed, defineAsyncComponent, ref } from 'vue';
import { CatalogTileLayoutOption, CatalogTileModel, LinkViewModel, MediaModel } from '@/types/B2BcontentServerContract';
import TextBlockHandler from '@/shared/content/blocks/helpers/TextBlockHandler.vue';
import { isReadable } from '@ctrl/tinycolor';

interface LinkOptions {
    showArrowIcon: boolean,
    styleAsButton: boolean,
    underlineOnHover: boolean,
}

export interface MediaTileContentBlockType {
    title: string,
    text: string,
    zoom?: boolean,
    media: MediaModel,
    isScrimEnabled: boolean,
    link: any,
    hexCode?: string, // for 50-50 slider
    subTitle?: string, // for collage tile
    soMeLinks?: LinkViewModel[], // for let's be friends
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: CatalogTileModel }



const asyncCatalogTileLandscape = defineAsyncComponent(() => import(/* webpackPrefetch: true */ '@/shared/content/blocks/catalog-layouts/CatalogTileLandscapeLayout.vue'));
const asyncCatalogTileLandscapeMirrored = defineAsyncComponent(() => import(/* webpackPrefetch: true */ '@/shared/content/blocks/catalog-layouts/CatalogTileLandscapeMirroredLayout.vue'));
const asyncCatalogTilePortrait = defineAsyncComponent(() => import(/* webpackPrefetch: true */ '@/shared/content/blocks/catalog-layouts/CatalogTilePortraitLayout.vue'));
const asyncCatalogTilePortraitMirrored = defineAsyncComponent(() => import(/* webpackPrefetch: true */ '@/shared/content/blocks/catalog-layouts/CatalogTilePortraitMirroredLayout.vue'));

const catalogLayout = computed<any>(() => {
    switch (props.content.layout) {
    case CatalogTileLayoutOption.Landscape:
        return asyncCatalogTileLandscape;
    case CatalogTileLayoutOption.LandscapeAndMirror:
        return asyncCatalogTileLandscapeMirrored;
    case CatalogTileLayoutOption.Portrait:
        return asyncCatalogTilePortrait;
    case CatalogTileLayoutOption.PortraitAndMirror:
        return asyncCatalogTilePortraitMirrored;
    default:
        return asyncCatalogTileLandscape;
    }
});

const mirrored = ref<boolean>(props.content.layout === CatalogTileLayoutOption.LandscapeAndMirror || props.content.layout === CatalogTileLayoutOption.PortraitAndMirror);

const flexOrderClass = computed<string>(() => {
    return mirrored.value ? 'sm:flex-row-reverse' : 'sm:flex-row';
});

const invertTextColor = computed<boolean>(() => {
    return !!props.content.backgroundColor && !isReadable('#000', props.content.backgroundColor);
});

const primaryMedia = computed<CatalogTileModel>(() => {
    return { ...props.content, media: props.content.primaryMedia };
});

const secondaryMedia = computed<CatalogTileModel>(() => {
    return { ...props.content, media: props.content.secondaryMedia };
});

const linkOptions = computed<LinkOptions>(() => {
    return {
        showArrowIcon: true,
        styleAsButton: false,
        underlineOnHover: true,
    };
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["flex flex-col w-full overflow-hidden mb-gutter p-20 sm:p-30 md:p-70", [_unref(flexOrderClass)]]),
    style: _normalizeStyle({ backgroundColor : __props.content.backgroundColor })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TextBlockHandler, {
        class: "sm:max-w-600 sm:mx-auto",
        heading: __props.content.subheading,
        title: __props.content.title,
        text: __props.content.text,
        "text-class": 'magic-line-on-child-links',
        "alternative-heading-variant": __props.content.useAlternativeStylingForSubheading,
        "invert-text-color": _unref(invertTextColor),
        "link-url": __props.content.link?.url,
        "link-target": __props.content.link?.target,
        "link-text": __props.content.link?.text,
        "link-is-spa-link": __props.content.link?.spaLink
      }, null, 8, ["heading", "title", "text", "alternative-heading-variant", "invert-text-color", "link-url", "link-target", "link-text", "link-is-spa-link"])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(catalogLayout)), {
      content: __props.content,
      "link-options": _unref(linkOptions),
      "invert-text-color": _unref(invertTextColor),
      "primary-media": _unref(primaryMedia),
      "secondary-media": _unref(secondaryMedia)
    }, null, 8, ["content", "link-options", "invert-text-color", "primary-media", "secondary-media"]))
  ], 6))
}
}

})